export class SaleAReceber {
    amountPaid: any;
    difference: any;
    clientSolds: any;
    formPayment: string;

    constructor(amountPaid: any, difference: any, clientSolds: any ,formPayment: string) {        
        this.amountPaid = amountPaid;
        this.difference = difference;
        this.clientSolds = clientSolds;        
        this.formPayment = formPayment;      
    }   
}